export const REINITIALIZE_STORE_STATE = 'REINITIALIZE_STORE_STATE';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';

/**
 * Account
 */
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';
